import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

// Async thunks for CRUD operations
export const fetchVaiTro = createAsyncThunk("vaiTro/fetchVaiTro", async () => {
  const res = await api.get("/medeco.role");
  return res.data?.content || [];
});

export const addVaiTro = createAsyncThunk("vaiTro/addVaiTro", async (data) => {
  const res = await api.post("/medeco.role", data);
  return res.data;
});

export const updateVaiTro = createAsyncThunk("vaiTro/updateVaiTro", async ({ id, ...data }) => {
  const res = await api.put(`/medeco.role/${id}`, data);
  return res.data;
});

export const deleteVaiTro = createAsyncThunk("vaiTro/deleteVaiTro", async (id) => {
  await api.delete(`/medeco.role/${id}`);
  return id;
});

// Lấy chi tiết vai trò, bao gồm node_ids hiện có
export const fetchVaiTroDetail = createAsyncThunk("vaiTro/fetchVaiTroDetail", async (id) => {
  const res = await api.get(`/medeco.role/${id}`);
  return res.data; // kỳ vọng: { id, name/tenVaiTro, node_ids: [] }
});

// Lấy cấu trúc cây quyền từ server
export const fetchPermissionsTree = createAsyncThunk("vaiTro/fetchPermissionsTree", async () => {
  const res = await api.get("/roles/permissions_tree");
  return res.data?.permissions_tree; // kỳ vọng: mảng các node { id, label, children: [] }
});

// Cập nhật quyền cho vai trò
export const updateRolePermissions = createAsyncThunk("vaiTro/updateRolePermissions", async ({ roleId, node_ids, name, desc }) => {
  const res = await api.post(`/roles/permissions/${roleId}`, { node_ids, name, desc });
  return res.data;
});

const vaiTroSlice = createSlice({
  name: "vaiTro",
  initialState: {
    list: [],
    loading: false,
    error: null,
    permissionsTree: [],
    permissionsLoading: false,
    permissionsError: null,
    selectedPermission: [],
  },
  reducers: {
    setSelectedPermission(state, action) {
      state.selectedPermission = Array.isArray(action.payload) ? action.payload : [];
    },
    clearSelectedPermission(state) {
      state.selectedPermission = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVaiTro.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVaiTro.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchVaiTro.rejected, (state) => {
        state.loading = false;
        // state.error = action.error.message;
      })
      .addCase(addVaiTro.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(updateVaiTro.fulfilled, (state, action) => {
        const idx = state.list.findIndex((v) => v.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteVaiTro.fulfilled, (state, action) => {
        state.list = state.list.filter((v) => v.id !== action.payload);
      })
      // fetchVaiTroDetail không cần lưu vào store list; dùng payload trực tiếp ở component
      .addCase(fetchVaiTroDetail.pending, () => {})
      .addCase(fetchVaiTroDetail.fulfilled, (state, action) => {
        const node_ids = action?.payload?.node_ids;
        state.selectedPermission = Array.isArray(node_ids) ? node_ids : [];
      })
      .addCase(fetchVaiTroDetail.rejected, () => {})
      // Permissions tree
      .addCase(fetchPermissionsTree.pending, (state) => {
        state.permissionsLoading = true;
        state.permissionsError = null;
      })
      .addCase(fetchPermissionsTree.fulfilled, (state, action) => {
        state.permissionsLoading = false;
        state.permissionsTree = action.payload || [];
      })
      .addCase(fetchPermissionsTree.rejected, (state, action) => {
        state.permissionsLoading = false;
        state.permissionsError = action.error?.message || "Lỗi tải cây quyền";
      })
      .addCase(updateRolePermissions.pending, () => {})
      .addCase(updateRolePermissions.fulfilled, () => {})
      .addCase(updateRolePermissions.rejected, () => {});
  },
});

export default vaiTroSlice.reducer;
